import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ProductImage } from './ProductImage';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 px-4 overflow-hidden bg-slate-950" data-id="element-45">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-teal-900/30 blur-[120px] rounded-full pointer-events-none" data-id="element-46"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-48">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-2" data-id="element-49">
            NO TERMINES MÁS EL DÍA AGOTADO
          </h1>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-teal-400 leading-tight" data-id="element-50">
            PREPARÁ CON ANTICIPACIÓN TUS PROTOCOLOS
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-4 max-w-md mx-auto" data-id="element-51">
          <ProductImage data-id="element-52" />
          <p className="text-center text-lg md:text-xl text-slate-300 font-medium mt-6" data-id="element-53">
            Sistema profesional para dejar de improvisar, optimizar tu tiempo
            clínico y obtener resultados reales en cada paciente.
          </p>
          <p className="text-center text-lg md:text-xl text-slate-400 font-medium mt-3" data-id="element-54">
            Mejorá tu consultorio en una semana
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-55">
          <CTAButton data-id="element-56" />
        </motion.div>
      </div>
    </section>;
}